import { BarbersByShopQuery } from './barbers-by-shop-query';
import { BrandShopsQuery } from './brand-shops-query';
export var endpoints = {
    brandShopsQuery: new BrandShopsQuery(),
    barbersByShopQuery: new BarbersByShopQuery(),
};
export * from './brand-shops-query';
